<template>


  <div class="base-wrapper">
    <div :class="{'uk-card-default': true, 'chartcard': true, fullscreen: fullscreen}">
      <a v-if="fullscreen" class="uk-alert-close" @click="() => {fullscreen=false; $store.dispatch('showHeader')}" uk-close></a>
      <a v-if="!fullscreen"class="uk-alert-close" uk-icon="icon: expand" @click="() => {fullscreen=true; $store.dispatch('hideHeader')}"></a>

      <div class="graph-section">
        <div class="uk-grid">
          <div class="uk-width-1-4@m graph-controller uk-grid-margin-small">

            <ul class="uk-flex-center graph-controller-tabs" uk-tab>
              <li id="chart-presets" :class="{'uk-active': controllerMode === 'presets'}"><a href="#"
                                                                                             @click="controllerMode = 'presets'"><span
                      uk-icon="icon: play"></span></a></li>
              <li id="chart-metrics" :class="{'uk-active': controllerMode === 'fieldList'}"><a href="#"
                                                                                               @click="controllerMode = 'fieldList'; ChartDemo='chart-metrics'"><span
                      uk-icon="icon: list"></span></a></li>
              <li id="chart-settings" :class="{'uk-active': controllerMode === 'settings'}"><a href="#"
                                                                                               @click="controllerMode = 'settings'"><span
                      uk-icon="icon: settings"></span></a></li>
            </ul>
            <!-- options accordion -->

            <div class='graph-controller-body uk-padding-small'>

              <!--  DEFAULT CHARTS HTML -->
              <div id="save-chart-section" class="save-form">
              <div v-if="!displaySaveForm" class="uk-button uk-button-default" @click="displaySaveForm=true">Save
                Chart
              </div>
              <div v-if="displaySaveForm">
                <float-field-input
                        :data="{placeholder: 'Volume and ATA Line Graph', label:'Chart Name'}"
                        @inputevent="(input) => {saveChartName=input}">
                </float-field-input>
                <div class="uk-button uk-button-primary" @click="saveChart">
                  <span class="icon" uk-icon="icon: upload"></span>
                  Save
                </div>
                <a href="#" style="display: block; margin-top: 1em;" @click="displaySaveForm=false">
                  <span class="icon" uk-icon="icon: close"></span>Cancel</a>
              </div>
            </div>

            <div v-if="controllerMode === 'presets'">
              <ul uk-accordion="multiple: true" id="prebuilt-chart-selector">
                <li class="uk-open"><a class="uk-accordion-title" href="#">Prebuilt Charts</a>
                  <div class="uk-accordion-content">
                    <div v-for="chart in defaultCharts">
                      <Chip
                              class="list-group-item"
                              :key="chart.name"
                              :data="chart"
                                :removeable="false"
                                @clickEvent="processDefaultSelection(chart.name)"
                        />
                      </div>
                    </div>
                  </li>
                  <li><a class="uk-accordion-title" href="#">Your Charts</a>
                    <div class="uk-accordion-content">
                      <div v-for="chart in userApi">
                         <Chip
                                class="list-group-item"
                                :key="chart.name"
                                :data="chart"
                                :removeable="false"
                                @clickEvent="processCustomApi(chart)"
                        />

                      </div>
                    </div>
                  </li>
                </ul>

              </div>

              <!--  SET FIELDLIST HTML -->
              <div v-if="controllerMode === 'fieldList'">
                <h4 class="control-section-header">Customize Chart Data</h4>
                <ul uk-accordion="multiple: true" id="chart-metricsList">
                  <li v-for="fieldCategory in Object.keys(fieldList)" :key="fieldCategory">
                    <a class="uk-accordion-title" href="#">{{deslug(fieldCategory)}}</a>
                    <div class="uk-accordion-content">
                      <draggable
                              class="dragArea list-group"
                              :list="fieldList[fieldCategory].metrics"
                              :sortable="false"
                              :group="{ name: 'fields', pull: 'clone', put: false }"
                              @move="startDrag"
                      >
                        <Chip
                                class="list-group-item"
                                v-for="element in fieldList[fieldCategory].metrics"
                                :key="element.name"
                                :data="element"
                                :secondary="element.type == 'percentage'"
                                :removeable="false"
                        />
                      </draggable>
                    </div>
                  </li>
                </ul>
              </div>


              <!--  SETTINGS HTML -->
              <div v-if="controllerMode === 'settings'">
                <h4 class="control-section-header">Chart Settings</h4>
                <ul uk-accordion="multiple: true">


                  <li :class="{'uk-open': true}">
                    <a class="uk-accordion-title" href="#">View data as:</a>
                    <div class="uk-accordion-content">
                      <!--<h5 class="settings-section-header">View data as:</h5>-->

<!--                      <ul class="uk-subnav uk-subnav-pill" uk-switcher>-->
                        <draggable
                                class="dragArea list-group"
                                :list="displayList"
                                :sortable="false"
                                :group="{ name: 'fields', pull: 'clone', put: false }"
                                @move="startDrag">
                          <button :class="{'uk-button': true, 'uk-button-text': mode !='timeseries', 'uk-button-primary': mode == 'timeseries', 'chart-select-button': true}" @click="mode = 'timeseries'">TIME SERIES</button>
                        </draggable>
                        <draggable
                                class="dragArea list-group"
                                :list="displayList"
                                :sortable="false"
                                :group="{ name: 'fields', pull: 'clone', put: false }"
                                @move="startDrag">
                          <button :class="{'uk-button': true, 'uk-button-text': mode !='summary', 'uk-button-primary': mode == 'summary', 'chart-select-button': true}" @click="mode = 'summary'">Time Period Summary</button>
                        </draggable>
                        <draggable
                                class="dragArea list-group"
                                :list="displayList"
                                :sortable="false"
                                :group="{ name: 'fields', pull: 'clone', put: false }"
                                @move="startDrag">
                          <button :class="{'uk-button': true, 'uk-button-text': mode !='heirarchy', 'uk-button-primary': mode == 'heirarchy', 'chart-select-button': true}" v-if="!isEmployee" @click="mode = 'heirarchy'">Compare Direct</button>
                        </draggable>
                        <draggable
                                class="dragArea list-group"
                                :list="displayList"
                                :sortable="false"
                                :group="{ name: 'fields', pull: 'clone', put: false }"
                                @move="startDrag">
                          <button :class="{'uk-button': true, 'uk-button-text': mode !='table', 'uk-button-primary': mode == 'table', 'chart-select-button': true}" v-if="!isEmployee" @click="mode = 'table'">Table</button>
                        </draggable>
<!--                      </ul>-->

                    </div>
                  </li>

                  <!-- heirarchy only: select time frame -->
                  <li :class="{'uk-open': true}" v-if="mode === 'heirarchy' || mode === 'table'">
                    <a class="uk-accordion-title" href="#">Time Period:</a>
                    <div class="uk-accordion-content">
                      <ul class="uk-subnav uk-subnav-pill" uk-switcher>

                        <li v-for="group in summaryConstraints.availableSummaryGroups"
                            :class="{'uk-active': selectedHeirarchySummaryGroup === group}"
                            :key="group">
                          <a href="#"
                             @click="() => {selectedHeirarchySummaryGroup = group; refresh++}">
                            {{ deslug(group) }}
                          </a>
                        </li>


                      </ul>
                    </div>
                  </li>


                  <!-- summary only: select time frame -->
                  <li :class="{'uk-open': true}" v-if="mode === 'summary'">
                    <a class="uk-accordion-title" href="#">Time Period:</a>
                    <div class="uk-accordion-content">
                      <ul class="uk-subnav uk-subnav-pill">

                        <li v-for="group in summaryConstraints.availableSummaryGroups"
                            :class="{'uk-active': summaryConstraints.selectedSummaryGroups.includes(group)}"
                            :key="group">
                          <a href="#"
                             @click="() => { toggleSummaryGroup(group) }">
                            {{ deslug(group) }}
                          </a>
                        </li>


                      </ul>
                    </div>
                  </li>

                  <!-- timeseries only: time_type filter -->
                  <li :class="{'uk-open': true}" v-if="mode === 'timeseries'">
                    <a class="uk-accordion-title" href="#">Time Increment:</a>
                    <div class="uk-accordion-content">
                      <ul class="uk-subnav uk-subnav-pill" uk-switcher>

                        <li v-if="availableTimeTypes.includes('Hour')"  :class="{'uk-active': this.timeSeriesConstraints.time_type==='Hour' }"><a href="#"  @click="() => {this.timeSeriesConstraints.time_type='Hour'; this.refresh++}">Hour</a></li>
                        <li v-if="availableTimeTypes.includes('Day')"   :class="{'uk-active': this.timeSeriesConstraints.time_type==='Day'  }"><a href="#"   @click="() => {this.timeSeriesConstraints.time_type='Day'; this.refresh++}">Day</a></li>
                        <li v-if="availableTimeTypes.includes('Week')"  :class="{'uk-active': this.timeSeriesConstraints.time_type==='Week' }"><a href="#" @click="() => {this.timeSeriesConstraints.time_type='Week'; this.refresh++}">Week</a></li>
                        <li v-if="availableTimeTypes.includes('Month')" :class="{'uk-active': this.timeSeriesConstraints.time_type==='Month'}"><a href="#" @click="() => {this.timeSeriesConstraints.time_type='Month'; this.refresh++}">Month</a></li>

                      </ul>
                    </div>
                  </li>


                  <!-- timeseries only: weekday filter -->
                  <li :class="{'uk-open': true}" v-if="mode === 'timeseries' && timeSeriesConstraints.time_type === 'Day'">
                    <a class="uk-accordion-title" href="#">Filter by Weekday:</a>
                    <div class="uk-accordion-content">
                      <ul class="uk-subnav uk-subnav-pill" uk-switcher>

                        <li :class="{'uk-active':!this.timeSeriesConstraints.week_day}"><a href="#" @click="() => {this.timeSeriesConstraints.week_day= null; this.refresh++}">None</a></li>
                        <li :class="{'uk-active': this.timeSeriesConstraints.week_day==='Mon'}"><a href="#" @click="() => {this.timeSeriesConstraints.week_day='Mon'; this.refresh++}">Monday</a></li>
                        <li :class="{'uk-active': this.timeSeriesConstraints.week_day==='Tue'}"><a href="#" @click="() => {this.timeSeriesConstraints.week_day='Tue'; this.refresh++}">Tuesday</a></li>
                        <li :class="{'uk-active': this.timeSeriesConstraints.week_day==='Wed'}"><a href="#" @click="() => {this.timeSeriesConstraints.week_day='Wed'; this.refresh++}">Wednesday</a></li>
                        <li :class="{'uk-active': this.timeSeriesConstraints.week_day==='Thu'}"><a href="#" @click="() => {this.timeSeriesConstraints.week_day='Thu'; this.refresh++}">Thursday</a></li>
                        <li :class="{'uk-active': this.timeSeriesConstraints.week_day==='Fri'}"><a href="#" @click="() => {this.timeSeriesConstraints.week_day='Fri'; this.refresh++}">Friday</a></li>
                        <li :class="{'uk-active': this.timeSeriesConstraints.week_day==='Sat'}"><a href="#" @click="() => {this.timeSeriesConstraints.week_day='Sat'; this.refresh++}">Saturday</a></li>
                        <li :class="{'uk-active': this.timeSeriesConstraints.week_day==='Sun'}"><a href="#" @click="() => {this.timeSeriesConstraints.week_day='Sun'; this.refresh++}">Sunday</a></li>

                      </ul>
                    </div>
                  </li>


                  <!-- timeseries only: weekday filter -->
                  <li :class="{'uk-open': true}"
                      v-if="mode === 'timeseries' && timeSeriesConstraints.time_type !== 'Hour'">
                    <a class="uk-accordion-title" href="#">From Date</a>
                    <div class="uk-accordion-content">
                      <!--disable before Jan 1 2017-->
                      <Datepicker
                              :inline="true"
                              v-model="timeSeriesConstraints.from"
                              :disabledDates="{to: new Date(2017, 0, 1)}"
                              @selected="refresh++"
                      />

                    </div>
                  </li>

                  <!-- timeseries only: weekday filter -->
                  <li :class="{'uk-open': true}"
                      v-if="mode === 'timeseries' && timeSeriesConstraints.time_type !== 'Hour'">
                    <a class="uk-accordion-title" href="#">To Date</a>
                    <div class="uk-accordion-content">
                      <Datepicker
                              :inline="true"
                              :disabledDates="{to: new Date(2017, 0, 1)}"
                              v-model="timeSeriesConstraints.to"
                              @selected="refresh++"
                      />
                    </div>
                  </li>


                </ul>

              </div>
            </div>
          </div>
          <div class="uk-width-3-4@m uk-flex-center">
                  <alert
                          v-if="error"
                          class="uk-alert-danger"
                          :data="{body: error,
                                  icon:'warning',
                                  }"
                  />
            <draggable
                    class="dragArea list-group chartarea"
                    :list="displayList"
                    :group="{ name: 'fields', pull: 'clone', put: () => true }"
                    :sortable="false"
                    @add="handleAdded"
            >

              <!--THIS IS WHERE THE CHARTS LIVE-->
              <h3  class="no-data-warning" v-if="noData">There is no data to display.</h3>
              <brush-chart :class="{'main-chart': true, ieBullshit: isIE}" :chartdata="chartData" v-if="chart_to_display==='line' && !noData"/>
              <grouped-bar :class="{'main-chart': true, ieBullshit: isIE}" :data="chartData" v-if="chart_to_display==='bar' && !noData"/>
              <scatter-set :class="{'main-chart': true, ieBullshit: isIE}" :data="chartData"
                           :datasegment="summaryConstraints.selectedHeirarchySummaryGroup"
                           :update-increment="updateIncrement"
                           v-if="chart_to_display == 'scatter' && !noData"
              />
              <data-table :name="displayName" :class="{'main-chart': true, ieBullshit: isIE}" v-if="chart_to_display == 'table' && !noData" :data="convertToTableFormat(chartData)"></data-table>
              <div class="chart-displayed-fields" v-if="!noData">
                <Chip
                        class="list-group-item"
                        v-for="element in displayList"
                        :key="element.name"
                        :data="element"
                        :color="element.color"
                        @remove="removeChip"
                />
              </div>
            </draggable>
          </div>
        </div>
      </div>

    </div>
      <spinner-overlay v-if="showOverlay"/>
    <Demo v-if="ChartDemo" :showName="ChartDemo"></Demo>
  </div>

</template>

<script>

	import BrushChart from "./charts/BrushChart"
	import GroupedBar from "./charts/GroupedBar"
	import ScatterSet from "./charts/ScatterSet"
    import DataTable from "./theme/DataTable"

  import Alert from './theme/Alert'

	import defaultCharts from "@/assets/utils/defaultCharts.js"


	import Chip from "./theme/Chips"

	import Draggable from "vuedraggable";
	import Datepicker from 'vuejs-datepicker';
	import Moment from 'moment';

	import SpinnerOverlay from "./theme/SpinnerOverlay"

	import api from '../store/apicall'
  import deslug from '../utils/deslug'
    import FloatFieldInput from "./theme/Input";
	import Demo from './theme/Demo'

    Array.prototype.diff = function(a) {
        return this.filter(function(i) {return a.indexOf(i) < 0;});
    };

	const chartColorPaletteStandard = [
		"#45237b",
		"#9d1779",
		"#dc2b61",
		"#ffa600",
		"#fe653d",
	]


	const chartColorPaletteStoplight = [
		"#C62828",
		"#2E7D32",
		"#FFD600"
	]

    function getCustomApi(_t) {
      api.post('/dashboard/', {'custom_api': 1}).then(function (response) {
        let data = response.data;
        console.log(data)
        data = data.map(d => {
          return {...d, parameters: JSON.parse(d.parameters)}
        });
        _t.userApi = data
      });
    }

	const populateFields = (context) => {

		//this can be removed once we fix the array to make a flat array. We should also no pass "other" category.
		const flattenData = (data) => {
			let flatArr = [];
			Object.keys(data).filter(d => d.toLowerCase() !== 'other').forEach((d) => {
				let internalArr = data[d].metrics.map(f => {
					return {...f, category: d}
				})
				flatArr = flatArr.concat(internalArr)
			})
			return flatArr;
		}


		return api.post('/dashboard/', {remind_me: 1})
				.then(res => {
					delete res.data['other'];
					context.fieldList = res.data;
					context.flatFieldList = flattenData(res.data)
				})
				.catch(err => console.error("Unable to get fieldlist", err))
	}


	export default {
		name: "DynamicCharts",
		components: {
          FloatFieldInput,
          BrushChart,
          Draggable,
          Chip,
          GroupedBar,
          ScatterSet,
          Datepicker,
          Alert,
          DataTable,
          SpinnerOverlay,
          Demo
		},
        props: ['slugUpdated'],
		data: function () {
			return {
			  ChartDemo: false,
			  showOverlay: false,
        displaySaveForm: false,
			  userApi: null,
              saveChartName: "",
              savingChart: false,
			  isIE: !(window.ActiveXObject) && "ActiveXObject" in window,
				//use to set new filters in data hosted locally and redraw charts
        //I also augment this as the last thing in the refresh cycle to trigger new draw if necessary.
				updateIncrement: 0,
        //use to trigger a new pull and update cycle from the server
        refresh: 0,
        error: null, //the error message to show. If null, nothing is shown.
				controllerMode: 'presets',
				colorSet: chartColorPaletteStandard,
				chartData: [],
				drag: {
					isDragging: false,
				},
				fieldList: [],
        flatFieldList: [], //uncategorized. useful for looking things up.
				displayList: [
					{name: "volume"},
					{name: "overall_sat_aaa_mgmt_all_avg"},
          {name: "ata_minus_pta_median"},
				],

				purpose: "timeseries",
				timeSeriesConstraints: {
					time_type: "Day",
					from: Moment().subtract(4, "months").toDate(),
					to: Moment().subtract(1, "days").toDate(),
					week_day: null,
				},
				summaryConstraints: {
					availableSummaryGroups: [
						"Prev_Month",
						"This_Month",
						"MTD_Prev_3_Months",
						"YTD",
						"MTD_Last_Year",
						"This_Calendar_Quarter",
					],
					selectedSummaryGroups: [
						"This_Month",
						"Prev_Month",
            "MTD_Last_Year",
					],
				},
        selectedHeirarchySummaryGroup: "prev_month", //heirarchy can only have one summary group;
				mode: null,
				requestMode: "heirarchy",
				chart_to_display: null,
				//store the default charts here;
				defaultCharts: defaultCharts("remind_me") || [],
        noData: false,
        request: null,
        fullscreen: false
			}
		},
		computed: {
			slug: function () {
				return this.$store.state.geography.data.slug;
			},
            isEmployee: function() {
			    return this.$store.state.geography.data.first_name;
            },
			slugType: function () {
			    let geography = this.$store.state.geography;
			    if (geography.data.first_name){
                    return this.$store.state.geography.data.position_type;
                } else {
                    return this.$store.state.geography.data.type;
                }

			},
            displayName: function() {
              let geography = this.$store.state.geography;
              if (geography.data.first_name) {
                return geography.data.first_name  + ' ' + geography.data.last_name
              } else {
                return geography.data.name
              }

            },
			requestObj: function () {

				//we need an ability to request data before we change the cahrt
        //that is why we have added requestMode.
        //we should always set it back to null on the other end of the promise to avoid conflicts
        const mode = this.requestMode ? this.requestMode : this.mode;

				let request;
				if (mode === "timeseries") {
					request = {
						slug: this.slug,
						type: this.slugType,
						purpose: "timeseries",
						parameters: {
							metrics: this.displayList.map(d => d.name),
							to: Moment(this.timeSeriesConstraints.to).format('YYYY-MM-DD'),
							from: Moment(this.timeSeriesConstraints.from).format('YYYY-MM-DD'),
							time_type: [this.timeSeriesConstraints.time_type],
              week_day: this.timeSeriesConstraints.week_day,
						}
					}
				} else if (mode === "summary") {
					request = {
						slug: this.slug,
						type: this.slugType,
						purpose: "calendar",
						parameters: {
							metrics: this.displayList.map(d => d.name),
							time_type: this.summaryConstraints.selectedSummaryGroups,
						}
					}
				} else if (mode === "heirarchy" || mode === "table") {
					request = {
						slug: this.slug,
						type: this.slugType,
						purpose: "calendar",
						parameters: {
							metrics: this.displayList.map(d => d.name),
							time_type: [this.selectedHeirarchySummaryGroup],
							relation: "children"
						}
					}
				}
				this.request = request;
				return request;
			},

			//for timeseries. Given a metric, and a timetype, see if the API supports the timetype for that metric. returns a boolean
			availableTimeTypes: function () {
				//thing we are going to return
				const availableTypes = [];
				//an array of the arrays of allowed time types for each element in displayList
				let arrayOfRules = [];

				//array of strings of displayed metrics
				const dMetrics = this.displayList.map(d => d.name);
				this.flatFieldList.filter(d => dMetrics.includes(d.name))
						.map(d => d.eligible_time_types).forEach(d => {
					arrayOfRules = [...arrayOfRules, ...d]
				})

				//at least one metric supports the time type.
				const allPossibilities = new Set(arrayOfRules)

				//now we make sure that all metrics support the timetype
				allPossibilities.forEach(d => {
					let count = arrayOfRules.filter(t => t === d).length
					if (count === dMetrics.length) availableTypes.push(d);
				})


				if (availableTypes.length === 1) {
					this.timeSeriesConstraints.time_type = availableTypes[0];
				}

				return availableTypes;

			},
		},
		methods: {
		  saveChart(){
		    this.savingChart = true;
            let saveRequest = JSON.parse(JSON.stringify(this.request.parameters))
            let submit_this = {
              parameters: JSON.stringify(saveRequest), //.replace(/"/g, "'"),
              purpose: this.request.purpose,
              name: this.saveChartName,
              chart_type: this.mode,
              save_custom_api: 1
            }
            let _t = this
            api.post('/dashboard/', submit_this).then(function(response){
              if (response.status == 201){
                getCustomApi(_t)
              } else {
                _t.error = response.data
              }
            }).catch(function(error){
              _t.error = error
            }).then(() => {
            	_t.displaySaveForm = false;
            })
          },
          convertToTableFormat(data) {
            let metrics_list = this.request.parameters.metrics
            // console.log("TRANFORM THIS", data)
            let output = []
            data.forEach(function(unit){
              let newRow = {}
              let name = unit.name;
              let slug = unit.id[2]
              let unit_id = unit.id[1]
              let unit_type = unit.id[0]
              let period = deslug(unit.groupName);
              let row = unit.data;

              //TODO: sometimes pdf doesnt handle undefined rows in cases where we have some of
              // one data point but not of the other below was an attempt to fix that, but it failed...

              // console.log(unit)
              // if (row.length != metrics_list.length){
              //     console.log(row)
              //     let row_metrics = row.map(r => r.label)
              //     let missing = metrics_list.diff(row_metrics)
              //     console.log("SHORT ROW", missing)
              //     missing.forEach(function(m) {
              //       row.push({
              //         label: m,
              //         value: null,
              //         date: null
              //       })
              //     })
              //     console.log("UPDATED ROW", row)
              // }


              row.forEach(function(col){
                if (col.date){
                  if (col.label.split('_').includes('sat')){
                    newRow['SAT_DATE'] = col.date.add(6, 'hours').format('MMMM-YYYY') // not sure why this only sometimes appears....
                  } else {
                    newRow['OPS_Date'] = col.date.add(6, 'hours').format('MMMM-YYYY') // not sure why this only sometimes appears....
                  }

                }
                newRow["Name"] = name;
                newRow["Period"] = period;
                newRow[col.label] = col.value;
                newRow['Link'] = '/dashboard/' + slug
                console.log(unit_type)
                if (unit_type == 'employee_id'){
                    newRow['Link'] = '/dashboard/' + unit_id
                }


              })
              output.push(newRow)
            })
            console.log("TABLE DATA", output)
            return output
          },
          deslug,
          handleAdded(added) {
            //this handles the adding of an object to the display list
            const _t = this;

            console.log(added.item.innerText);
            if (_t.displayList.length > 5) {
              _t.displayList = _t.displayList.filter(d => this.deslug(d.name).toLowerCase() !== added.item.innerText.toLowerCase())
              _t.error = "You can only view five metrics at a time in the graph."
              return;
            }

            //first we ensure that it is not a duplicate
            this.displayList.map(d => d.name).forEach((d, i, a) => {
              if (!(a.indexOf(d) === i)) { //we have a duplicate
                _t.displayList.splice(i, 1);
              }
            })

            _t.pullNewData();
          },

          removeChip(data) {
            this.displayList = this.displayList.filter(d => d.name !== data.name)
            const desiredFields = this.displayList.map(d => d.name)

            if (this.mode === 'timeseries') { //filter out the whole group
              this.chartData = this.chartData.filter(d => desiredFields.includes(d.groupName));
            } else { // we need to filter the fields within the group
              this.chartData = this.chartData.map(g => {
                let field_data = g.data.filter((d) => desiredFields.includes(d.label, d.date));
                return {...g, data: field_data}
              })
            }

            if (this.mode === 'heirarchy' || this.mode === 'table') { //need to refresh data for now to update the charts. This is just to avoid developing a whole new process
              this.pullNewData();
            }

          },

          startDrag(evt) {

            return null
          },

          pullNewData(request) {
            const _t = this;

            //optionally manually pass in the dictionary. Else, use the generated one.
            if (!request) request = _t.requestObj
            console.log("REQUEST BEING MADE", request)
            return api.post('/dashboard/', request)
                    .then(res => {

                      //Some requests come as an array of arrays, other as just a single array fo dictionaries,
                      // so we have to detect which first.
                      // console.log("initial response", Moment(res.data[0].data[0].date).format('MM-DD-YYYY'))
                      const cData = Array.isArray(res.data[0]) ? res.data[0] : res.data;
                      console.log("cData", cData)


                      const empty = this.checkIfEmpty(cData);
                      if (empty) return;


                      //color is in the group for timeseries, and in the field for all other charts.
                      //mode switching is causing some bugs here, so going to apply it to both group AND field
                      //even though only one is being used.
                      //can be optimized.

                      _t.chartData = cData.map((d, i) => {
                        return {...d, color: _t.colorSet[i]}
                      });


                      //make sure it's all the same type
                      const types = []
                      //hold the error message
                      let error_msgs = []

                      // color is the field for other charts.
                      // So we put it at both the group level and field level so we don't have to worry about it
                      _t.chartData = _t.chartData.map((g) => {

                        //push error messages
                        if (g.error) error_msgs.push(g.error)
                        if (g.error) console.log("ERROR ERROR ERROR", g.error)

                        g.data.forEach((d, i) => {
                          d.color = _t.colorSet[i];
                          d.date = new Moment(d.date)
                          types.push(d.value_type);
                        })

                        return g
                      })

                      //apply colors to fieldlist now to ensure a match.
                      _t.displayList = _t.displayList.map((d, i) => {
                        return {...d, color: _t.colorSet[i]}

                      });


                      if (error_msgs.length) {
                        _t.error = "It looks like you might have the wrong time type set for these metrics. Try a different one in the settings tab."
                        //open settings bar
                        _t.controllerMode = "settings";
                      } else if (new Set(types).size > 1 && _t.mode !== "scatter" && _t.mode != null) {
                        console.log("ERROR MODE", _t.mode)
                        _t.error = "Heads Up! You've mixed percentage and numerical values together. " +
                                "Try using only blue (numerical) or purple (percentage) chips in the chart "
                      } else {
                        _t.error = null;
                      }

                    })
                    .catch(err => {
                      console.error("data update err", err)
                    })
                    .then(() => _t.updateIncrement += 1)
          },

          //handle selection of default requests
          processCustomApi(chart){
		    console.log(chart)
            const _t = this;

            const request = JSON.parse(JSON.stringify(chart));
            delete request['name'];
            delete request['id'];
            delete request['user'];
            request['slug'] = _t.slug;
            request['type'] = _t.slugType;
            this.request = request;
            console.log("REQUEST", request)

            if (request.purpose == 'timeseries') {
              _t.timeSeriesConstraints.time_type = request.parameters.time_type;
            };

            _t.displayList = [];
            _t.displayList = request.parameters.metrics.map(d => {
              return {name: d}
            });

            this.requestMode = request.chart_type;

              this.pullNewData(request)
                    .then(() => {
                      _t.mode = _t.requestMode;
                      _t.requestMode = null;
                    })
                    .catch(() => {
                      throw new Error("Default chart request failed")
                    })

          },
          processDefaultSelection(chartname) {
		    console.log(chartname)

            const _t = this;

            const request = defaultCharts(chartname, _t.slug, _t.slugType)


            if (request.mode === 'timeseries') {
              _t.timeSeriesConstraints.time_type = request.parameters.time_type;
            }


            //update all the appropriate fields
            _t.displayList = [];
            _t.displayList = request.parameters.metrics.map(d => {
              return {name: d}
            });

            this.requestMode = request.mode;

            this.pullNewData()
                    .then(() => {
                      _t.mode = _t.requestMode;
                      _t.requestMode = null;
                      _t.showOverlay=false;

                    })
                    .catch(() => {
                      throw new Error("Default chart request failed")
                    })

          },

          checkIfEmpty(cData) {
            ///checks if the data set is empty
            let count = 0;
            cData.forEach(g => {
              g.data.forEach((d, i) => {
                if (d.value) count++;
              })
            })

            this.noData = !count;
            return !count;
          },

          toggleSummaryGroup: function (group) {
            const index = this.summaryConstraints.selectedSummaryGroups.indexOf(group);
            if (index >= 0) {
              this.summaryConstraints.selectedSummaryGroups.splice(index, 1);
            } else {
              this.summaryConstraints.selectedSummaryGroups.push(group);
            }

            this.refresh++;

          }

        },
      watch: {
        mode: function () {
          const _t = this;

          const chart_type_map = {
            summary: 'bar',
            timeseries: 'line',
            heirarchy: 'scatter',
            table: 'table'
          }

          //presets pull new data on click. avoid double pull

          if (_t.controllerMode === 'presets') {
            _t.chart_to_display = chart_type_map[_t.mode]
          } else {
            console.log("pull new data flag")
            _t.pullNewData()
                    .then(() => _t.chart_to_display = chart_type_map[_t.mode]);
          }
        },

        refresh: function () {
          console.log("PULLING NEW DATA")
          this.pullNewData();
        },

        error: function () {
          if (this.error) {
            setTimeout(() => this.error = null, 6000)
          }
        },
        slugUpdated: function() {
          if (this.slugUpdated){
            if (this.slugType != 'Driver'){
                this.processDefaultSelection("child_ops")
            } else {
                this.processDefaultSelection("timeseries_volume")
            }
            // this.showOverlay=false;
          }
        },

      },
      mounted() {
        console.log("MOUNTED")
        this.showOverlay=true
        const _t = this;
        getCustomApi(_t);
        console.log("IS THIS IE OR not", this.isIE);
        populateFields(_t)
        if ((_t.slug == _t.$route.params.slug || !_t.$route.params.slug) && _t.slugUpdated){
            console.log("slug hasnt changed...")
            if (this.slugType != 'Driver'){
                this.processDefaultSelection("child_ops")
            } else {
                this.processDefaultSelection("timeseries_volume")
            }


        }

        // _t.showOverlay=true;
        // setTimeout(function(){
        //     this.processDefaultSelection("child_ops")
        //     _t.showOverlay = false;
        // }, 100)




        // this.pullNewData()
        //         .then(() => populateFields(_t))
        //         .then(() => {
		// 				_t.mode = 'heirarchy';
		// 				_t.chart_to_display = 'scatter';
		// 			})
      }
	}
</script>



<style lang="less">

  @import "../assets/less/theme.less";

  .uk-button {
    width: 100%;
    margin-bottom: 15px;
  }

  .graph-section {
    padding-left: 1.5em;
  }

  .graph-controller-tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    max-width: 100%;
    margin-bottom: 0;

    &::-webkit-scrollbar {
      width: 0;
    }

  }

  .graph-controller {
    margin-top: 2vh;
    padding-left: 10%;
    overflow-x: hidden;

    .graph-controller-body {
      max-height: 65vh;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 0;
      }

      .control-section-header {
        color: @secondary-3;
      }

      // the action accordion object
      li {
        text-align: left;
        padding: 2px 4%;
      }
    }
  }

  .settings-section-header {
    font-weight: bold;
    font-size: 14px;
  }

  .uk-subnav-pill {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;

    li > a {
      border-radius: 4px;
      font-size: 13px;

    }

    .uk-active > a {
      background-color: @secondary-1;
    }
  }

  .chartarea {
    overflow-y: hidden;

    &::-webkit-scrollbar {
      display: none;
    }

  }


  .no-data-warning {
    margin-top: 150px;
    opacity: .6;
  }

  .base-wrapper{
    /*background-color: whitesmoke;*/
    /*border: black solid 2px;*/
    border-radius: 10px;
  }


  .uk-subnav-pill {

    a {
      white-space: nowrap;
      width: unset!important;
    }

  }


  .vdp-datepicker__calendar {


    .cell.selected {
      background-color: @secondary-2;
      color: white;
    }

    .cell {
      color: @secondary-3;

      &:hover {
        border-color: @secondary-3;
      }
    }

    span.next::after {
      border-left-color: @primary-2;
    }

    span.prev::after {
      border-right-color: @primary-2;
    }
  }


    @media (min-width: @breakpoint-medium) {

    .main-chart {
      margin-top: 5vh;
      max-height: 70vh;
      overflow-y: scroll;

      &.ieBullshit {
        height: 800px;

      }

      &::-webkit-scrollbar {
        opacity: 0;
      }
    }

    .uk-subnav-pill {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

    .settings-section-header {
      text-align: left;
      /*margin-left: 10%;*/
    }

     .vdp-datepicker__calendar {
       width: 200px !important;
     }

  }


  .chartcard {
    position: relative;
    background-color: white!important;
  }


  .uk-alert-close {
    position: absolute;
    top: 15px;
    right: 15px;
  }

  .fullscreen {
    position: fixed!important;
    z-index: 200;
    height: 94vh;
    width: 94vw;
    top: 3vh;
    left: 3vw;
  }


  .chart-displayed-fields {
     margin: 30px auto;
  }

  .chart-select-button {
    text-align: left !important;
    margin-top: 5px !important;
  }


    .save-form {
      margin-bottom: 1em;
    }


    span.icon {
      margin-right: 10px;
    }


    .uk-accordion-title {
      /*text-decoration: underline;*/
      font-weight: bold;

    }

    #save-chart-section {
      border: 1px solid #c7c7c7;
      padding: 10px;
      border-radius: 3px;

    }

</style>
